export default __webpack_public_path__ + "static/media/happy_smiley_face.7d347bbc.png";